import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationService } from '../Configuration/configuration.service';
import { BaseEntityModel } from '../Data/Models/Common/base-entity-model';
import { UserLicenseDetailsModel } from '../Data/Models/Users/user-license-details-model';
import { User } from '../Data/Models/Users/user';
import { LocalStorageService } from '../Shared/common/local-storage.service';
import { UsersApiService } from '../Shared/common/users-api.service';
import moment from 'moment';
import { OAuthService } from 'angular-oauth2-oidc';
import { CharityDataShareServiceService } from '../components/charity/charities/services/charity-data-share-service.service';
import { LoginapiService } from '../components/auth/Pages/services/loginapi.service';
import { SessionTimeOutModel } from '../Data/Models/Common/session-time-out-model';
import { BaseEntityResponse1 } from '../Data/Models/Common/base-entity-model1';

//const baseUrl = `${environment.baseUrl}/users`;
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: "root"
})

export class AuthService {
  baseUrl: any = this.configService.getAPIBaseUrl() + '/users';
  //baseUrl: any = "https://localhost:44365/api/Users";
  currentUserSubject = new BehaviorSubject<User|null>(null);
  currentUser: Observable<User>;
  currentUserLicenseDetailsSubject = new BehaviorSubject<UserLicenseDetailsModel|null>(null);
  currentUserLicenseDetails = this.currentUserLicenseDetailsSubject.asObservable();
  isLicenceExpired: boolean;
  userFullName: string;
  userEmail: string;
  constructor(private http: HttpClient, private lsService: LocalStorageService, private configService: ConfigurationService, private userLicenseApi: UsersApiService, private oauthService: OAuthService, private datashareservice: CharityDataShareServiceService, private loginService: LoginapiService) {
    //Get current user from local storage and store to the 'BehaviorSubject'
    const currentUser = localStorage.getItem("currentUser")
   // this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(currentUser));
    //Set 'BehaviorSubject' to 'currentUser' property so later any one can subscribe to this property and get the current user
 //   this.currentUser = this.currentUserSubject.asObservable();
    this.isLicenceExpired = localStorage.getItem("isLicenceExpired") == "true" ? true : false;
  }

  //Get current user directly from 'BehaviorSubject' without subscribe to 'currentUser' property
  get currentUserValue(): User|null {
    return this.currentUserSubject.value;
  }
  get currentUserLicenseDetailsValue(): UserLicenseDetailsModel|null {
    return this.currentUserLicenseDetailsSubject.value;
  }

  //Login
  logIn(userName: string): Observable<BaseEntityModel<User>> {
    this.loginService.setSession(true)
    return this.http.post<BaseEntityModel<User>>(this.baseUrl + "/authenticate", { userName }, httpOptions);
  }
  //User Licensing Details
  checkUserLicenseDetails() {
    
    if (this.lsService.getCurrentUser?.userID != null && this.lsService.getCurrentUser?.userID != undefined) {
      this.userLicenseApi.getUserLicenseDetails(
        (this.lsService.getCurrentUser?.centralUserID != null) ?
          this.lsService.getCurrentUser?.userID : this.lsService.getCurrentUser.createdBy
      ).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
        if (data.status == 0) {
          if (data.entity != null && data.entity.length > 0) {
            
            this.userFullName = data.entity[0].userName;
            this.userEmail = data.entity[0].emailID;

            this.currentUserLicenseDetailsSubject.next(data.entity[0]);
            const licenceDetails = this.currentUserLicenseDetailsValue;
            if (licenceDetails != null) {
              if (licenceDetails.userStatus) {
                if (moment(licenceDetails.tuEndDate).isBefore(new Date())) {
                  this.isLicenceExpired = true;
                  this.datashareservice.setExpiredpopup(true);
                  localStorage.setItem("isLicenceExpired", "true");
                  localStorage.setItem("isLicenceExpireddate", moment(licenceDetails.tuEndDate).format("DD/MM/YYYY"));
                }
                else {
                  localStorage.setItem("isLicenceExpireddate", moment(licenceDetails.tuEndDate).format("DD/MM/YYYY"));
                  this.datashareservice.setExpiredpopup(false);
                  localStorage.setItem("isLicenceExpired", "false");
                }
              }
              else {
                this.logOut;
                this.oauthService.logOut()
              }
            }
          }
          else {
            this.currentUserLicenseDetailsSubject.next(null);
          }
        }
      })
    }
  }
  //Logout
  logOut() {
    //Remove everything from localstorage
    localStorage.clear();
    sessionStorage.clear();
    //Send null to 'BehaviorSubject' so anyone subscribed to this can be notified
    this.currentUserSubject.next(null);
    this.currentUserLicenseDetailsSubject.next(null);
  }
  GetUserSession(UserId: number): Observable<BaseEntityResponse1<SessionTimeOutModel>> {
    var url = `${this.baseUrl}/RetrieveUserSession?UserId=${UserId}`
    return this.http.get<BaseEntityResponse1<SessionTimeOutModel>>(url);
  }
  UpdateSession(sessionTimeOut: SessionTimeOutModel): Observable<BaseEntityResponse1<SessionTimeOutModel>> {
    var url = `${this.baseUrl}/UpdateUserSession`
    return this.http.post<BaseEntityResponse1<SessionTimeOutModel>>(url, sessionTimeOut);
  }
}
